/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'

export const useTableModel = () => {
  const { t } = useTranslation()

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <MainTableActionButtons row={row} overridePermissions={true} />,
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('common.title')}`,
      field: 'title',
      order: false,
      width: '90%',
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}